import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {}

  toggleComplete() {
    const checkbox = event.target;
    const taskId = checkbox.dataset.taskId;

    if (!taskId) {
      return;
    }

    $.ajax({
      url: `/tasks/${taskId}/xhr_toggle_completed`,
      type: 'PATCH',
    }).done(() => {
      const row = document.querySelector(`.dashboard-line[data-task-id="${taskId}"]`);

      row.classList.toggle('dashboard-line--task-completed');
      row
        .querySelector('.dashboard-line__task-title')
        .classList.toggle('dashboard-line__task-title--strikethrough');
    });
  }
}
